import { Grid, Skeleton } from '@mui/material'

import { Body1White } from '@/components/typography'
import TokenIcon from '@/components/common/TokenIcon'

const AmountWithIcon = ({ uiAmount, symbol, logoUri }: { uiAmount: string; symbol: string; logoUri: string }) => {
  return (
    <Grid container>
      <Grid item container xs="auto" alignContent="center">
        {uiAmount === '' && (
          <Grid item container xs="auto" alignContent="center">
            <Grid item xs="auto">
              <Skeleton variant="text" width={70} />
            </Grid>
            <Grid item xs>
              <Body1White sx={{ color: 'var(--Ebony-Clay-300, #AAB3CF)' }}>
                {uiAmount}{' '}
                <span style={{ color: 'var(--Ebony-Clay-500, #7C8AB4)', fontWeight: 300, marginLeft: '4px' }}>
                  {symbol}
                </span>
              </Body1White>
            </Grid>
          </Grid>
        )}
        {uiAmount !== '' && (
          <Body1White sx={{ color: 'var(--Ebony-Clay-300, #AAB3CF)' }}>
            {uiAmount}{' '}
            <span style={{ color: 'var(--Ebony-Clay-500, #7C8AB4)', fontWeight: 300, marginLeft: '4px' }}>
              {symbol}
            </span>
          </Body1White>
        )}
      </Grid>
      <Grid item container xs ml="4px" alignContent="center">
        <TokenIcon logoUri={logoUri} size={16} tokenSymbol={symbol} />
      </Grid>
    </Grid>
  )
}

export default AmountWithIcon
